import './bootstrap';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import AnnualConference from '@/Pages/AnnualConference.vue';
import Attendees from '@/Pages/Register/Attendees.vue';
import Avatar from '@/Components/Avatar.vue';
import LoginForm from '@/Components/LoginForm.vue';
import MenuLink from '@/Components/MenuLink.vue';
import SingleEvent from '@/Pages/SingleEvent.vue';
import UpcomingEvents from '@/Pages/UpcomingEvents.vue';

//Initialize the store
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

//Make sure we have the right elements in the page
let loginEl = document.getElementById('login-form');

if (loginEl) {
	const login = createApp(LoginForm);
	login.use(pinia);
	login.mount(loginEl);
}

//Avatar
document.querySelectorAll('.avatar').forEach((el) => {
	const avatar = createApp(Avatar);
	avatar.use(pinia);
	avatar.mount(el);
});

//Conditional menu link
document.querySelectorAll('.sign-in-menu-item').forEach((el) => {
	const link = createApp(MenuLink);
	link.use(pinia);
	link.mount(el);
});

//Upcoming Events
let upcomingEventsEl = document.getElementById('upcoming-events');

if (upcomingEventsEl) {
	const upcomingEvents = createApp(UpcomingEvents);
	upcomingEvents.use(pinia);
	upcomingEvents.mount(upcomingEventsEl);
}

//Annual Conference
let annualConferenceEl = document.getElementById('annual-conference-cta');

if (annualConferenceEl) {
	const annualConference = createApp(AnnualConference);
	annualConference.use(pinia);
	annualConference.mount(annualConferenceEl);
}

//Single Event
let singleEventEl = document.getElementById('single-event');

if (singleEventEl) {
	const singleEvent = createApp(SingleEvent);
	singleEvent.use(pinia);
	singleEvent.mount(singleEventEl);
}

//Registration
let registrationEl = document.getElementById('event-registration');

if (registrationEl) {
	const registration = createApp(Attendees);
	registration.use(pinia);
	registration.mount(registrationEl);
}